import { render } from "./Slides.vue?vue&type=template&id=2dfbde12&scoped=true"
import script from "./Slides.vue?vue&type=script&lang=js"
export * from "./Slides.vue?vue&type=script&lang=js"

import "./Slides.vue?vue&type=style&index=0&id=2dfbde12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfbde12"],['__file',"src/components/Slides.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2dfbde12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dfbde12', __exports__)) {
    console.log('reload')
    api.reload('2dfbde12', __exports__)
  }
  
  module.hot.accept("./Slides.vue?vue&type=template&id=2dfbde12&scoped=true", () => {
    console.log('re-render')
    api.rerender('2dfbde12', render)
  })

}


export default __exports__